import React, { useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => { api.get("/faqs").then(r => setFaqs(r.data)).catch(() => {}); }, []);

  const grouped = useMemo(() => {
    const g = {};
    faqs.forEach(f => { (g[f.category] = g[f.category] || []).push(f); });
    return g;
  }, [faqs]);

  return (
    <div data-testid="faq-page">
      <section className="bg-scu-obsidian text-white">
        <div className="mx-auto max-w-[1400px] px-4 lg:px-8 py-20">
          <div className="text-xs uppercase tracking-[0.35em] text-scu-electric">Help</div>
          <h1 className="mt-3 font-bebas text-6xl md:text-8xl tracking-wider">FAQ</h1>
        </div>
        <div className="stripe-divider" />
      </section>

      <section className="mx-auto max-w-4xl px-4 lg:px-8 py-16 space-y-10">
        {Object.keys(grouped).length === 0 && <div className="text-scu-smoke">FAQs coming soon.</div>}
        {Object.entries(grouped).map(([cat, list]) => (
          <div key={cat}>
            <div className="text-xs uppercase tracking-[0.3em] text-scu-purple font-bold">{cat}</div>
            <h2 className="mt-2 font-bebas text-3xl tracking-wide text-scu-obsidian">{cat} Questions</h2>
            <Accordion type="single" collapsible className="mt-4 bg-white border border-scu-smoke/15 rounded-md divide-y divide-scu-smoke/15">
              {list.map((f) => (
                <AccordionItem key={f.id} value={f.id} className="px-5">
                  <AccordionTrigger data-testid={`faq-${f.id}`} className="text-left font-bold text-scu-obsidian hover:no-underline">{f.question}</AccordionTrigger>
                  <AccordionContent className="text-scu-smoke leading-relaxed">{f.answer}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        ))}
      </section>
    </div>
  );
}
